export default __webpack_public_path__ + "images/a9329b6449c4340c457397cb7f1b732b.svg";